import { useCallback, useMemo } from 'react';

/**
 * Hook to obfuscate email address from spambots
 * The email is split and reassembled only on user interaction
 */
const useObfuscatedEmail = () => {
  // Email parts - obfuscated to prevent scraping
  const parts = useMemo(() => ({
    user: 'allen',
    domain: 'leyaouanc',
    tld: 'com'
  }), []);

  // Assemble email only when needed
  const getEmail = useCallback(() => {
    return `${parts.user}@${parts.domain}.${parts.tld}`;
  }, [parts]);

  // Display text with visual obfuscation (looks normal to users)
  const displayEmail = useMemo(() => {
    return `${parts.user}@${parts.domain}.${parts.tld}`;
  }, [parts]);

  // Handle click - construct mailto dynamically
  const handleEmailClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = `mailto:${getEmail()}`;
  }, [getEmail]);

  return {
    displayEmail,
    handleEmailClick,
    getEmail
  };
};

export default useObfuscatedEmail;
